<template>
  <div class="mainDiv">
    <div class="topDiv"  >
      <div class="backDiv" @click="handleRoute">
        <img
          height="24"
          width="24"
          src="../../../assets/userDetails/left-arrow.svg"
        />
        <p>Back</p>
      </div>
      <!-- <div>
        <img
          height="24"
          width="24"
          src="../../../assets/userDetails/left-grey-arrow.svg"
        />
        <img
          height="24"
          width="24"
          src="../../../assets/userDetails/right-arrow.svg"
        />
      </div> -->
    </div>
    <div class="containerr" v-if="crops&&data&&brands">

      <main-container :data="data[0]" :crops="crops" :brands="brands" v-if="crops"/>
   
    </div>
    <div class="loader" v-else >
        <v-progress-circular
          :width="6"
          :size="80"
          color="green"
          indeterminate
        ></v-progress-circular>
      </div>
  </div>
</template>

<script>
import mainContainer from "./components/main-container.vue";
import API_URL from "../../../helpers/apiUrls";
import router from '../../../router';
export default {
  name: "User",
  data() {
    return {
      data:null,
      crops:null,
      brands:null,
    };
  },
  created(){
    const id = this.$route.params.id;
    this.getUserDetails(id)
    this.getUserCropDetails(id)
    this.getUserBrandsDetails(id)
  },
  methods: {
    getUserDetails(id) {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("Crop Stage", response.data);
         this.data = response.data;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      const data = {};
      this.requestGET(
        `${API_URL.user_details}?user_id=${id}`,
        data,
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    getUserCropDetails(id) {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("Crop Stage", response.data);
         this.crops = response.data;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      const data = {};
      this.requestGET(
        `${API_URL.user_crop_detials}?user_id=${id}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
     getUserBrandsDetails(id) {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("Brand Stage", response.data);
         this.brands = response.data;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      const data = {};
      this.requestGET(
        `${API_URL.user_brand_details}?user_id=${id}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    handleRoute(){
      router.replace({ name: "userlist" })
    }
  },
  components: {
    "main-container": mainContainer,
  },
};
</script>
<style lang="scss" scoped>
.mainDiv {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 48px;
  background: #f8faf8;
}
.topDiv {
  height: 11px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.backDiv {
  display: flex;
  height: 100px;
   margin-top:-20px
}
.containerr {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
  padding: 0;
}
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh;
    margin-top:20%
}
</style>
